import { all } from 'redux-saga/effects';
import download from './download';
import insert from './insert';
import changeSpeakerNames from './changeSpeakerNames';

export default function* rootSaga() {
  yield all([
    // FIXME: #646 do we need this?
    download(),
    insert(),
    changeSpeakerNames(),
  ]);
}



// WEBPACK FOOTER //
// ./redux/sagas/transcript/index.js